require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-uganda-reproductive-maternal-and-child-health-improvement.json") })
        }
      }, "path---en-us-project-uganda-reproductive-maternal-and-child-health-improvement");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-uganda-reproductive-maternal-and-child-health-improvement!./.cache/json/en-us-project-uganda-reproductive-maternal-and-child-health-improvement.json
// module id = 570
// module chunks = 231608221292675